module.exports = __webpack_public_path__ + "img/MOH ind.42003a66.jpg";